module.exports = __webpack_public_path__ + "static/media/mirror-example-1.a4eba71f.png";